import { useEffect, useState } from "react";

export type Theme = "light" | "dark";

const STORAGE_KEY = "teia:theme";

export function getTheme(): Theme {
  const current = document.documentElement.dataset.theme;
  return current === "dark" ? "dark" : "light";
}

export function useTheme(): [Theme, () => void] {
  const [theme, setTheme] = useState<Theme>(getTheme);

  useEffect(() => {
    document.documentElement.dataset.theme = theme;
    try {
      localStorage.setItem(STORAGE_KEY, theme);
    } catch {
      // armazenamento indisponível (modo privado); o tema só não persiste
    }
    window.dispatchEvent(new CustomEvent("teia:theme", { detail: theme }));
  }, [theme]);

  return [
    theme,
    () =>
      setTheme((current) => {
        const next = current === "dark" ? "light" : "dark";
        // síncrono: efeitos de componentes filhos rodam antes do efeito deste hook
        // e precisam ler o tema novo (ex.: recolorir o grafo)
        document.documentElement.dataset.theme = next;
        return next;
      }),
  ];
}

/** Lê uma variável CSS do tema atual (usado pelo grafo para acompanhar o tema). */
export function cssVar(name: string): string {
  return getComputedStyle(document.documentElement).getPropertyValue(name).trim();
}
